export const Header = {
  Card: {
    backgroundColor: '#fff',
    width: '100%',
    display: 'flex',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.06)',
    borderRadius: 0,
  },
  Box: {
    marginLeft: '16px',
    marginTop: '16px',
  },
  Typography: {
    marginLeft: '12px',
    marginTop: '24px',
    marginBottom: '24px',
    fontFamily: 'Montserrat',
    fontSize: 16,
    fontWeight: 'bold',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#3c3c3c',
  },
  DocumentTypography: {
    marginLeft: '12px',
    marginTop: '24px',
    marginBottom: '24px',
    fontFamily: 'Montserrat',
    fontSize: 16,
    fontWeight: 'bold',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#fff',
  },
  Document: {
    backgroundColor: '#2F6358',
    boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.06)',
    width: '100%',
    borderRadius: 0,
    color: '#FFF',
  },
};

export const AddOns = {
  Card: {
    marginLeft: '16px',
    marginRight: '16px',
    padding: '16px',
    backgroundColor: '#fff',
    display: 'flex',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.06)',
    borderRadius: 2,
    marginTop: '8px',
    alignItems: 'center',
    '#arrowright': {
      marginLeft: 'auto',
    },
  },
  CardHidden: {
    marginLeft: '16px',
    marginRight: '16px',
    padding: '16px',
    backgroundColor: '#fff',
    display: 'none',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.06)',
    borderRadius: 2,
    marginTop: '8px',
    alignItems: 'center',
    '#arrowright': {
      marginLeft: 'auto',
    },
  },
  Typography: {
    marginBottom: '8px',
    marginTop: '24px',
    marginLeft: '16px',
    color: '#3C3C3C',
    fontSize: 16,
    fontFamily:
    'Montserrat',
    fontWeight: '600',
    wordWrap: 'break-word',
  },
  Title: {
    marginLeft: '8px',
    color: '#616161',
    fontSize: 12,
    fontFamily: 'Montserrat',
    fontWeight: '600',
    wordWrap: 'break-word',
  },
};

export const OrderBox = {
  Typography: {
    marginTop: '16px',
    marginLeft: '16px',
    fontFamily: 'Montserrat',
    fontSize: 16,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#3c3c3c',
  },
  TypographySample: {
    marginTop: '18px',
    marginLeft: '16px',
    fontFamily: 'Montserrat',
    fontSize: 16,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#3c3c3c',
  },
  Card: {
    marginTop: '12px',
    marginLeft: '16px',
    marginRight: '16px',
    borderRadius: 2,
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.06)',
  },
  SuccessCard: {
    display: 'flex',
    marginTop: '12px',
    marginLeft: '16px',
    marginRight: '16px',
    borderRadius: 2,
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.06)',
    '#lottiesuccess': {
      marginTop: '16px',
    },
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  SuccessReq: {
    marginTop: '24px',
    height: 18,
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'center',
    color: '#3c3c3c',
  },
  CardTypoRequest: {
    marginLeft: '16px',
    marginTop: '12px',
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#616161',
  },
  CardTypoVial: {
    marginLeft: '16px',
    marginTop: '12px',
    marginBottom: '12px',
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#616161',
  },
  CallCustomer: {
    marginLeft: '12px',
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#616161',
  },
  CallCard: {
    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 8px',
    display: 'flex',
    alignItems: 'center',
    height: '56px',
  },
  CallIcon: {
    marginLeft: '16px',
    padding: 0.8,
    fontSize: 18,
    color: '#fff',
    backgroundColor: '#28B463',
    borderRadius: '50%',
  },
  CustomerName: {
    marginLeft: '16px',
    marginTop: '16px',
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#616161',
  },
  CardTypoVialSuccess: {
    marginTop: '12px',
    height: 20,
    fontFamily: 'Montserrat',
    fontSize: 16,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'center',
    color: '#3c3c3c',
  },
  SuccessDetails: {
    marginTop: '16px',
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'center',
    color: '#616161',
  },
  SuccessDetailsEx: {
    marginBottom: '24px',
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'center',
    color: '#616161',
  },
};

export const None = {
  display: 'none',
};

export const Member = {
  MemberTypo: {
    marginLeft: '16px',
    marginTop: '16px',
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#616161',
  },
  Accordion: {
    marginTop: '8px',
    marginLeft: '16px',
    marginRight: '16px',
    boxShadow: 'rgba(149, 157, 165, 0.1) 0px -8px 16px',
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    '&:before': {
      display: 'none',
    },
    '&.Mui-expanded': {
      margin: '8px 16px 0px',
      borderBottomLeftRadius: 8,
      borderBottomRightRadius: 8,
    },
  },
  AccordionExpanded: {
    marginTop: '8px',
    marginLeft: '16px',
    marginRight: '16px',
    boxShadow: 'rgba(149, 157, 165, 0.1) 0px -8px 16px',
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    '&:before': {
      display: 'none',
    },
    '&.Mui-expanded': {
      margin: '8px 16px 0px',
      borderBottomLeftRadius: 8,
      borderBottomRightRadius: 8,
    },
  },
  ArrowIcon: {
    width: 24,
    height: 24,
  },
  AccordionSummaryBox: {
    display: 'flex',
    alignItems: 'center',
    maxWidth: '200px',
  },
  AccordionSummary: {
    borderBottom: '1px solid #f6f6f6',
    '.MuiAccordionSummary-content': {
      margin: '16px 0px',
    },
    '&.Mui-expanded': {
      minHeight: '1px',
      '.MuiAccordionSummary-content': {
        margin: '16px 0px',
      },
    },
  },
  Name: {
    marginLeft: '8px',
    fontFamily: 'Montserrat',
    fontSize: 16,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#616161',
  },
  NameDisabled: {
    marginLeft: '8px',
    fontFamily: 'Montserrat',
    fontSize: 16,
    fontWeight: '600',
    opacity: 0.5,
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#616161',
  },
  AgeDisabled: {
    height: 16,
    opacity: 0.5,
    marginLeft: '8px',
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#616161',
    span: {
      color: '#D9D9D9',
    },
  },
  Age: {
    height: 16,
    marginLeft: '8px',
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#616161',
    span: {
      color: '#D9D9D9',
    },
  },
  AccordionDetails: {
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 4,
  },
  BottomBox: {
    backgroundColor: '#fff',
    marginLeft: '16px',
    marginRight: '16px',
    boxShadow: 'rgba(149, 157, 165, 0.1) 0px 8px 16px',
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
  },
  VialsReported: {
    marginLeft: '18px',
    paddingTop: '12px',
    paddingBottom: '12px',
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#616161',
  },
  VialsReportedDone: {
    marginLeft: '18px',
    paddingTop: '12px',
    paddingBottom: '12px',
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#01b37a',
  },
};

export const Vial = {
  Card: {
    marginTop: '8px',
  },
  CardOpacity: {
    marginTop: '8px',
    opacity: 0.6,
  },
  VialText: {
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    marginLeft: '2px',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#9d9d9d',
    b: {
      fontFamily: 'Montserrat',
      fontSize: 12,
      fontWeight: '600',
      fontStyle: 'normal',
      letterSpacing: 0,
      color: '#01b37a',
    },
  },
  ScanBox: {
    marginTop: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  VialName: {
    marginLeft: '12px',
    width: `${window.screen.width * 0.5}px`,
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#616161',
  },
  UavBadge: {
    height: '32px',
    display: 'flex',
    borderRadius: 1,
    marginTop: '16px',
    marginBottom: '16px',
    backgroundColor: '#f6f6f6',
    alignItems: 'center',
  },
  UavDes: {
    width: '4px',
    borderBottomRightRadius: 5,
    borderTopRightRadius: 5,
    height: '24px',
    backgroundColor: '#b39901',
  },
  UavText: {
    marginLeft: '8px',
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#616161',
  },
  ListText: {
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#9d9d9d',
  },
  ListDot: {
    marginRight: '4px',
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#9d9d9d',
  },
  Button: {
    display: 'flex',
    width: 72,
    height: 32,
    borderRadius: 2,
    backgroundColor: '#ffffff',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#ff970a',
    color: '#ff970a',
  },
  ScanText: {
    textTransform: 'none',
    marginLeft: '4px',
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#ff970a',
  },
  ScannedBox: {
    display: 'flex',
  },
  ScannedTick: {
    marginTop: '8px',
    height: '13.3px',
    width: '13.3px',
    color: '#01b37a',
  },
  UploadButton: {
    display: 'flex',
    width: 90,
    height: 32,
    borderRadius: 2,
    backgroundColor: '#fff',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#ff970a',
    color: '#ff970a',
    ':hover': {
      borderColor: '#ff970a',
      backgroundColor: '#fff',
      color: '#ff970a',
    },
  },
  UploadButtonOffline: {
    display: 'flex',
    width: 50,
    height: 32,
    borderRadius: 2,
    backgroundColor: '#fff',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#F44336',
    color: '#F44336',
    ':hover': {
      borderColor: '#F44336',
      backgroundColor: '#fff',
      color: '#F44336',
    },
  },
  UploadedButton: {
    display: 'flex',
    width: 90,
    height: 32,
    borderRadius: 2,
    backgroundColor: '#ff970a',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#ff970a',
    color: '#fff',
    ':hover': {
      borderColor: '#ff970a',
      backgroundColor: '#ff970a',
      color: '#fff',
    },
  },
  UploadText: {
    textTransform: 'none',
    marginLeft: '4px',
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#ff970a',
    ':hover': {
      color: '#ff970a',
    },
  },
  UploadTextOffline: {
    textTransform: 'none',
    marginLeft: '4px',
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#F44336',
    ':hover': {
      color: '#F44336',
    },
  },
  UploadIcon: {
    color: '#ff970a',
    fontSize: 18,
  },
  RecordIcon: {
    color: '#ff970a',
    fontSize: 16,
  },
  RecordIconOffline: {
    color: '#F44336',
    fontSize: 16,
  },
  Scanned: {
    marginLeft: '4px',
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#01b37a',
  },
  SkippedBox: {
    display: 'flex',
  },
  SkippedTick: {
    marginTop: '8px',
    height: '13.3px',
    width: '13.3px',
    color: '#b39901',
  },
  Skipped: {
    marginLeft: '4px',
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#b39901',
  },
  List: {
    li: {
      fontFamily: 'Montserrat',
      fontSize: 12,
      fontWeight: '500',
      fontStyle: 'normal',
      letterSpacing: 0,
      color: '#9d9d9d',
    },
    display: 'grid',
    marginLeft: '4px',
    marginTop: '12px',
    img: {
      marginLeft: '8px',
    },
  },
  MoreActions: {
    borderRadius: 2,
    marginTop: '16px',
    backgroundColor: '#ffffff',
    borderStyle: 'solid',
    borderWidth: 1,
    color: '#d8d8d8',
    borderColor: '#d8d8d8',
  },
  MoreActionsText: {
    marginLeft: '1px',
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#616161',
    textTransform: 'none',
  },
  ButtonChevron: {
    height: 16,
    marginRight: '1px',
    width: 16,
    color: '#616161',
  },
  Divider: {
    marginTop: '16px',
    marginBottom: '16px',
    borderColor: '#F6F6F6',
  },
  DividerReasons: {
    marginTop: '12px',
    marginBottom: '12px',
    borderColor: '#f6f6f6',
  },
  TextField: {
    marginTop: '6px',
    '.MuiInputBase-formControl': {
      padding: '12px 8px',
    },
    display: 'flex',
    borderRadius: 4,
    textarea: {
      height: 16,
      fontFamily: 'Montserrat',
      fontSize: 12,
      fontWeight: '500',
      fontStyle: 'normal',
      letterSpacing: 0,
    },
  },
  ReasonTextField: {
    marginTop: '8px',
    fieldset: {
      borderRadius: 2,
      border: '1px solid #ffd59b',
    },
    textarea: {
      fontFamily: 'Montserrat',
      fontSize: 12,
      fontWeight: '500',
      fontStyle: 'normal',
      letterSpacing: 0,
      color: '#3c3c3c',
    },
  },
};

export const More = {
  Dialog: {
    height: '600px',
    '.MuiDialog-container': {
      height: 'auto',
      bottom: 0,
      position: 'fixed',
      width: '100%',
    },
    '.MuiPaper-root': {
      margin: 0,
      width: '100%',
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderTopLeftRadius: 12,
      borderTopRightRadius: 12,
    },
  },
  DialogVitals: {
    height: '600px',
    '.MuiDialog-container': {
      height: 'auto',
      bottom: 0,
      position: 'fixed',
      width: '100%',
    },
    '.MuiPaper-root': {
      margin: 0,
      width: '100%',
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderTopLeftRadius: 12,
      borderTopRightRadius: 12,
    },
  },
  VialId: {
    marginTop: '24px',
    marginLeft: '24px',
    height: 16,
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#9d9d9d',
  },
  VialChangeHeader: {
    marginTop: '24px',
    marginLeft: '24px',
    height: 19,
    fontFamily: 'Montserrat',
    fontSize: 16,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#3c3c3c',
  },
  DeleteText: {
    marginTop: '24px',
    marginLeft: '24px',
    height: 19,
    fontFamily: 'Montserrat',
    fontSize: 16,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#3c3c3c',
    marginBottom: '16px',
  },
  DeleteSubText: {
    marginBottom: '4px',
    marginTop: '16px',
    marginLeft: '24px',
    marginRight: '24px',
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#616161',
  },
  VitalsSubTextModal: {
    marginBottom: '12px',
    marginTop: '16px',
    marginLeft: '24px',
    marginRight: '24px',
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#616161',
  },
  DeleteSubTextRed: {
    marginBottom: '4px',
    marginTop: '16px',
    marginLeft: '24px',
    marginRight: '24px',
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#E74C3C',
  },
  DeleteSubTextSplit: {
    marginTop: '4px',
    marginLeft: '24px',
    marginRight: '24px',
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#616161',
  },
  DelayHeader: {
    marginBottom: '24px',
    marginTop: '24px',
    marginLeft: '24px',
    height: 19,
    fontFamily: 'Montserrat',
    fontSize: 16,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#3c3c3c',
  },
  DelayDetails: {
    height: 32,
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#616161',
    marginBottom: '16px',
  },
  DelayBox: {
    marginLeft: '24px',
    marginRight: '24px',
  },
  VialChangeCurrent: {
    marginLeft: '24px',
    height: 18,
    marginTop: '8px',
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#616161',
  },
  CurrentVialBox: {
    backgroundColor: '#f6f6f6',
    borderRadius: 2,
    padding: '8px',
    marginTop: '8px',
    marginLeft: '24px',
    marginRight: '24px',
    marginBottom: '16px',
  },
  ChangeVialName: {
    height: 16,
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#616161',
  },
  VialName: {
    marginLeft: '24px',
    marginBottom: '16px',
    height: 20,
    fontFamily: 'Montserrat',
    fontSize: 16,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#3c3c3c',
  },
  Header: {
    display: 'flex',
    justifyContent: 'space-between',
    borderBottom: '1px solid #f6f6f6',
  },
  HeaderChange: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  DeleteHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    borderBottom: '1px solid #f6f6f6',
  },
  HeaderBox: {
    borderBottom: '1px solid #f6f6f6',
  },
  ButtonBox: {
    marginLeft: '24px',
    marginRight: '24px',
    marginBottom: '48px',
  },
  Button: {
    marginTop: '16px',
    display: 'flex',
    textTransform: 'none',
    justifyContent: 'space-between',
    width: '100%',
    height: 64,
    borderRadius: 2,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#f6f6f6',
    img: {
      marginLeft: '8px',
    },
  },
  CloseIcon: {
    marginBottom: '2px',
    marginTop: '31px',
    marginRight: '24px',
    height: '24px',
    width: '24px',
    color: '#979797',
  },
  CloseIconChange: {
    marginBottom: '2px',
    marginTop: '24px',
    marginRight: '24px',
    height: '24px',
    width: '24px',
    color: '#979797',
  },
  ButtonText: {
    marginBottom: '2px',
    flex: '0 0 auto',
    marginLeft: '8px',
    marginRight: 'auto',
    height: 18,
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#616161',
  },
  ButtonArrow: {
    marginRight: '16px',
    color: '#9a9a9a',
    width: '18px',
    height: '18px',
  },
  TestsIncluded: {
    height: 18,
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#616161',
    marginBottom: '16px',
    marginTop: '16px',
  },
  ChangeVialBox: {
    marginLeft: '24px',
    marginRight: '24px',
    maxHeight: `${window.screen.height * 0.5}px`,
    overflowY: 'auto',
  },
  FormControl: {
    marginBottom: '16px',
    width: '100%',
    '.MuiFormControlLabel-label': {
      fontFamily: 'Montserrat',
      fontSize: 12,
      fontWeight: '500',
      fontStyle: 'normal',
      letterSpacing: 0,
      color: '#616161',
    },
  },
  FormControlChange: {
    width: '100%',
    '.MuiFormControlLabel-label': {
      fontFamily: 'Montserrat',
      fontSize: 12,
      fontWeight: '500',
      fontStyle: 'normal',
      letterSpacing: 0,
      color: '#616161',
    },
  },
  TestsIncludedBox: {
    marginLeft: '24px',
    marginRight: '24px',
    maxHeight: `${window.screen.height * 0.55}px`,
    overflowY: 'auto',
  },
  RadioSkip: {
    svg: {
      height: 24,
      width: 24,
    },
    '.MuiRadio-root': {
      color: '#d8d8d8',
    },
    '.Mui-checked': {
      color: '#01b37a!important',
    },
  },
  TestsCheckBox: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '16px',
  },
  TestName: {
    marginLeft: '8px',
    height: 16,
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#616161',
  },
  CheckBox: {
    width: 24,
    height: 24,
    borderRadius: 4,
    color: '#d8d8d8',
    '&.Mui-checked': {
      color: '#01b37a',
    },
  },
  UpdateTestsBox: {
    boxShadow: '0 -2px 6px 0 rgba(0, 0, 0, 0.08)',
  },
  DeleteBottomBox: {
    marginTop: '16px',
    boxShadow: '0 -2px 6px 0 rgba(0, 0, 0, 0.08)',
  },
  Loader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  UpdateTests: {
    height: 48,
    borderRadius: 2,
    backgroundColor: '#ff970a',
    color: '#fff',
    width: '100%',
    boxShadow: '0 2px 12px 0 rgba(255, 151, 10, 0.31)',
    ':hover': {
      backgroundColor: '#ff970a',
      color: '#fff',
    },
  },
  DeleteLeft: {
    height: 48,
    marginRight: '8px',
    borderRadius: 2,
    backgroundColor: '#fff',
    color: '#616161',
    width: '100%',
    border: '1px solid #d8d8d8',
    ':hover': {
      border: '1px solid #d8d8d8',
      backgroundColor: '#fff',
      color: '#616161',
    },
  },
  DeleteRight: {
    height: 48,
    marginLeft: '8px',
    borderRadius: 2,
    backgroundColor: '#fff',
    color: '#616161',
    width: '100%',
    border: '1px solid #e60709',
    ':hover': {
      border: '1px solid #e60709',
      backgroundColor: '#fff',
      color: '#616161',
    },
  },
  UpdateTestsText: {
    height: 20,
    textTransform: 'none',
    fontFamily: 'Montserrat',
    fontSize: 16,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'center',
    color: '#ffffff',
  },
  DeleteTestsRightText: {
    height: 20,
    textTransform: 'none',
    fontFamily: 'Montserrat',
    fontSize: 15,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'center',
    color: '#e60709',
  },
  DeleteTestsLeftText: {
    textTransform: 'none',
    fontFamily: 'Montserrat',
    fontSize: 15,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'center',
    color: '#616161',
  },
  UpdateTestsBoxChild: {
    marginLeft: '24px',
    marginRight: '24px',
    marginTop: '16px',
    marginBottom: '16px',
  },
  DeleteButtonsBox: {
    marginLeft: '24px',
    marginRight: '24px',
    marginTop: '16px',
    marginBottom: '16px',
    display: 'flex',
  },
};

export const VitalStyles = {
  Card: {
    fontFamily: 'Montserrat',
    backgroundColor: '#fff',
    marginLeft: '16px',
    marginRight: '16px',
    marginTop: '12px',
    borderRadius: 2,
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.06)',
  },
  VitalsText: {
    marginLeft: '22px',
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#616161',
  },
  Divider: {
    marginLeft: '22px',
    marginRight: '16px',
    marginTop: '12px',
    marginBottom: '12px',
    color: '#F6F6F6',
  },
  VitalsTextSided: {
    marginLeft: '8px',
    marginRight: '16px',
    width: 160,
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#616161',
  },
  OtherBox: {
    marginTop: '24px',
    marginRight: '16px',
    display: 'flex',
    alignItems: 'center',
  },
  OtherBoxBottom: {
    marginTop: '24px',
    marginRight: '16px',
    marginBottom: '16px',
    display: 'flex',
    alignItems: 'center',
  },
  BPBox: {
    marginTop: '12px',
    marginLeft: '16px',
    marginRight: '16px',
    display: 'flex',
    alignItems: 'center',
  },
  BPTextField: {
    width: '100%',
    marginLeft: '6px',
    borderRadius: 2,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#d8d8d8',
    '&$disabled $notchedOutline': {
      borderColor: 'orange',
    },
    '.MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '.MuiInputBase-root': {
      paddingLeft: 0,
    },
    color: '#616161',
    '.MuiInputBase-input': {
      height: 3,
      fontFamily: 'Montserrat',
      fontSize: 14,
      fontWeight: '500',
      fontStyle: 'normal',
      letterSpacing: 0,
      color: '#3c3c3c',
    },
  },
  BPTextFieldLeft: {
    width: '100%',
    borderRadius: 2,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#d8d8d8',
    '&$disabled $notchedOutline': {
      borderColor: 'orange',
    },
    '.MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '.MuiInputBase-root': {
      paddingLeft: 0,
    },
    color: '#616161',
    '.MuiInputBase-input': {
      height: 3,
      fontFamily: 'Montserrat',
      fontSize: 14,
      fontWeight: '500',
      fontStyle: 'normal',
      letterSpacing: 0,
      color: '#3c3c3c',
    },
  },
  Slash: {
    color: '#616161',
    fontSize: 18,
    marginLeft: 1,
    marginRight: 1,
    transform: 'scaleY(1.5)',
  },
  GenerateButton: {
    fontFamily: 'Montserrat',
    border: '1px solid #ff970a',
    color: '#ff970a',
    width: '100%',
    textTransform: 'none',
    borderRadius: 2,
    padding: 1,
  },
  ButtonBox: {
    marginTop: '32px',
    marginLeft: '16px',
    marginRight: '16px',
    marginBottom: '24px',
    textAlign: 'center',
  },
  ErrorText: {
    fontSize: 12,
    color: 'red',
    fontFamily: 'Montserrat',
  },
  ErrorBox: {
    marginTop: '8px',
    height: '18px',
  },
};

export const OtpModalStyles = {
  None: {
    display: 'none',
  },
  Modal: {
    height: '600px',
    '.MuiDialog-container': {
      height: 'auto',
      bottom: 0,
      position: 'fixed',
      width: '100%',
    },
    '.MuiPaper-root': {
      margin: 0,
      width: '100%',
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderTopLeftRadius: 24,
      borderTopRightRadius: 24,
    },
  },
  OtpInputContainer: {
    marginLeft: '24px',
    marginTop: '12px',
  },
  NumberError: {
    marginLeft: '24px',
    marginTop: '8px',
    height: 16,
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#fe0a0a',
  },
  ActionText: {
    marginTop: '24px',
    marginLeft: '24px',
    height: 19,
    fontFamily: 'Montserrat',
    fontSize: 16,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#3c3c3c',
    marginBottom: '16px',
  },
  ActionSubTextHeader: {
    marginBottom: '4px',
    marginTop: '12px',
    marginLeft: '24px',
    marginRight: '24px',
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#3c3c3c',
  },
  ActionSubText: {
    marginBottom: '4px',
    marginLeft: '24px',
    marginRight: '24px',
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#616161',
  },
  ActionSubHeading: {
    marginBottom: '4px',
    marginLeft: '24px',
    marginRight: '24px',
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#616161',
  },
  ActionSubTextRed: {
    marginBottom: '4px',
    marginTop: '16px',
    marginLeft: '24px',
    marginRight: '24px',
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#CB0000',
    backgroundColor: '#FCF2F2',
    padding: '12px',
    borderRadius: '8px',
    border: '1px solid #CB0000',
  },
  ActionSubTextGreyed: {
    marginBottom: '4px',
    marginTop: '16px',
    marginLeft: '24px',
    marginRight: '24px',
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#616161',
    backgroundColor: '#EEEEEE',
    padding: '12px',
    borderRadius: '8px',
    border: '1px solid #757575',
  },
  HrefForceCancel: {
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    color: '#757575',
  },
  ActionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    borderBottom: '1px solid #f6f6f6',
  },
  CloseIconChange: {
    marginBottom: '2px',
    marginTop: '24px',
    marginRight: '24px',
    height: '24px',
    width: '24px',
    color: '#979797',
  },
  ActionBottomContainer: {
    marginTop: '16px',
    boxShadow: '0 -2px 6px 0 rgba(0, 0, 0, 0.08)',
  },
  ActionRight: {
    height: 48,
    borderRadius: 2,
    backgroundColor: '#ff970a',
    color: '#616161',
    width: '100%',
    ':hover': {
      backgroundColor: '#ff970a',
      color: '#616161',
    },
  },
  ActionRightText: {
    height: 20,
    textTransform: 'none',
    fontFamily: 'Montserrat',
    fontSize: 15,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'center',
    color: '#fff',
  },
  ActionButton: {
    marginLeft: '24px',
    marginRight: '24px',
    marginTop: '16px',
    marginBottom: '32px',
    display: 'flex',
  },
  Boxes: {
    marginTop: '12px',
    '.MuiInputBase-root': {
      maxWidth: '48px',
      maxHeight: '48px',
    },
    '.MuiInputBase-input': {
      border: 0,
    },
    '.MuiInputBase-formControl': {
      borderColor: '#f1f1f1',
      border: '0px solid',
      borderRadius: '12px',
    },
    '.Mui-focused': {
      borderColor: '#fe0a0a',
      border: '0px solid',
      borderRadius: '12px',
    },
  },
  BoxesError: {
    marginTop: '12px',
    '.MuiInputBase-root': {
      maxWidth: '48px',
      maxHeight: '48px',
    },
    '.MuiInputBase-input': {
      border: 0,
    },
    '.MuiInputBase-formControl': {
      borderColor: '#f1f1f1',
      border: '0px solid',
      borderRadius: '12px',
    },
    '.Mui-focused': {
      borderColor: '#fe0a0a',
      border: '0px solid',
      borderRadius: '12px',
    },
    '.MuiOutlinedInput-notchedOutline': {
      borderColor: '#fe0a0a',
    },
  },
  DidNotRecieve: {
    marginTop: '12px',
    marginLeft: '24px',
    marginBottom: '8px',
    height: 16,
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#616161',
  },
  Resend: {
    textDecoration: 'underline',
    marginLeft: '5px',
    height: 16,
    display: 'inline',
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#9d9d9d',
  },
  ResendCountdown: {
    textDecoration: 'underline',
    marginLeft: '5px',
    height: 16,
    display: 'inline',
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#fe970a',
  },
  InfoContainer: {
    marginTop: '16px',
    marginBottom: '48px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
};

export const RequestSent = {
  BodyContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: '24px',
  },
  RequestSentText: {
    fontFamily: 'Montserrat',
    fontSize: 16,
    fontWeight: '600',
    marginTop: '16px',
  },
  Dialog: {
    height: '600px',
    '.MuiDialog-container': {
      height: 'auto',
      bottom: 0,
      position: 'fixed',
      width: '100%',
    },
    '.MuiPaper-root': {
      margin: 0,
      width: '100%',
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderTopLeftRadius: 24,
      borderTopRightRadius: 24,
    },
  },
  ActionBottomContainer: {
    marginTop: '16px',
    boxShadow: '0 -2px 6px 0 rgba(0, 0, 0, 0.08)',
  },
  ActionRight: {
    height: 48,
    borderRadius: 2,
    backgroundColor: '#ff970a',
    color: '#616161',
    width: '100%',
    ':hover': {
      backgroundColor: '#ff970a',
      color: '#616161',
    },
  },
  ActionRightText: {
    height: 20,
    textTransform: 'none',
    fontFamily: 'Montserrat',
    fontSize: 15,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'center',
    color: '#fff',
  },
  ActionButton: {
    marginLeft: '24px',
    marginRight: '24px',
    marginTop: '16px',
    marginBottom: '16px',
    display: 'flex',
  },
};

export const NewMemStyles = {
  Drawer: {
    '.MuiPaper-root': {
      borderTopLeftRadius: '24px',
      borderTopRightRadius: '24px',
    },
  },
  Radio: {
    color: '#D8D8D8',
    height: 24,
    width: 24,
  },
  RadioSpaced: {
    color: '#D8D8D8',
    height: 24,
    width: 24,
    marginLeft: '16px',
  },
  DrawerReturn: {
    '.MuiPaper-root': {
      backgroundColor: '#F6F7F2',
      borderTopLeftRadius: '24px',
      borderTopRightRadius: '24px',
    },
  },
  WhoTested: {
    color: 'black', fontSize: 14, fontFamily: 'Montserrat', fontWeight: '600', wordWrap: 'break-word',
  },
  WhoTestedSub: {
    color: '#616161', fontSize: 12, fontFamily: 'Montserrat', fontWeight: '500', wordWrap: 'break-word',
  },
  AddMember: {
    marginTop: '8px',
    color: '#3C3C3C',
    fontSize: 16,
    fontFamily: 'Montserrat',
    fontWeight: '600',
    wordWrap: 'break-word',
  },
  Direction: {
    marginTop: '24px',
    color: '#616161',
    fontSize: 12,
    fontFamily: 'Montserrat',
    fontWeight: '500',
    wordWrap: 'break-word',
    sup: {
      color: 'red',
    },
  },
  DirectionAge: {
    marginTop: '16px',
    color: '#616161',
    fontSize: 12,
    fontFamily: 'Montserrat',
    fontWeight: '500',
    wordWrap: 'break-word',
    sup: {
      color: 'red',
    },
  },
  TextField: {
    width: '100%',
    marginTop: '8px',
    '.MuiInputBase-root': {
      height: '40px',
      borderRadius: '8px',
    },
    '.MuiInputBase-input': {
      color: '#3C3C3C', fontSize: 14, fontFamily: 'Montserrat', fontWeight: '500', wordWrap: 'break-word',
    },
  },
  TextFieldError: {
    width: '100%',
    marginTop: '8px',
    '.MuiOutlinedInput-notchedOutline': {
      borderColor: 'red',
    },
    '.MuiInputBase-root': {
      height: '40px',
      borderRadius: '8px',
    },
    '.MuiInputBase-input': {
      color: '#3C3C3C', fontSize: 14, fontFamily: 'Montserrat', fontWeight: '500', wordWrap: 'break-word',
    },
  },
  AgeBox: {
    display: 'flex',
    maxHeight: '92px',
  },
  TextFieldAge: {
    marginTop: '8px',
    marginBottom: '100px',
    '.MuiInputBase-root': {
      height: '40px',
      borderRadius: '8px',
    },
    '.MuiInputBase-input': {
      color: '#3C3C3C', fontSize: 14, fontFamily: 'Montserrat', fontWeight: '500', wordWrap: 'break-word',
    },
  },
  TextFieldAgeError: {
    marginTop: '8px',
    marginBottom: '100px',
    '.MuiOutlinedInput-notchedOutline': {
      borderColor: 'red',
    },
    '.MuiInputBase-root': {
      height: '40px',
      borderRadius: '8px',
    },
    '.MuiInputBase-input': {
      color: '#3C3C3C', fontSize: 14, fontFamily: 'Montserrat', fontWeight: '500', wordWrap: 'break-word',
    },
  },
  YearsText: {
    '.MuiTypography-root': {
      color: '#616161', fontSize: 12, fontFamily: 'Montserrat', fontWeight: '500', wordWrap: 'break-word',
    },
  },
  RadioText: {
    color: '#616161', fontSize: 14, fontFamily: 'Montserrat', fontWeight: '500', wordWrap: 'break-word', marginLeft: '2px',
  },
  RadioTextSelected: {
    color: '#01B37A', fontSize: 14, fontFamily: 'Montserrat', fontWeight: '500', wordWrap: 'break-word', marginLeft: '2px',
  },
  NumberError: {
    color: 'rgb(213, 46, 45)',
    fontSize: '12px',
    lineHeight: 0.8,
  },
  NoNumberError: {
    display: 'none',
  },
  ErrorBox: {
    marginTop: '12px',
    height: '16px',
  },
  NoErrorBox: {
    height: '16px',
    marginTop: '6px',
    backgroundColor: '#fff',
  },
  ErrorBoxLeft: {
    marginTop: '6px',
    height: '16px',
    width: '40%',
  },
  NoErrorBoxLeft: {
    height: '16px',
    marginTop: '6px',
    width: '40%',
    backgroundColor: '#fff',
  },
  ErrorBoxFlex: {
    marginLeft: '8px',
    marginTop: '6px',
    height: '16px',
  },
  NoErrorBoxFlex: {
    marginLeft: '8px',
    height: '16px',
    marginTop: '8px',
    backgroundColor: '#fff',
  },
  RadioBox: {
    '& .MuiSvgIcon-root': {
      fontSize: '20px',
    },
    display: 'flex',
    alignItems: 'center',
    marginTop: '16px',
    '.Mui-checked': {
      color: '#01B37A!important',
    },
  },
  ButtonBox: {
    boxShadow: '0px -2px 8px 0px rgba(0, 0, 0, 0.12)',
  },
  DividerBox: {
    display: 'flex',
    justifyContent: 'center',
    padding: '20px',
  },
  AddNewMember: {
    color: '#FF970A',
    fontSize: 14,
    marginRight: '8px',
    fontFamily: 'Montserrat',
    fontWeight: '600',
    wordWrap: 'break-word',
  },
  Divider: {
    marginTop: '16px',
    marginBottom: '16px',
    borderColor: '#F6F6F6',
  },
  NoOfMembers: {
    color: '#616161',
    fontSize: 14,
    fontFamily: 'Montserrat',
    fontWeight: '600',
    wordWrap: 'break-word',
    marginBottom: '8px',
  },
  PatientBox: {
    marginTop: '8px',
    display: 'flex',
    '#radiocheck': {
      marginLeft: 'auto',
    },
    backgroundColor: '#fff',
    padding: '16px',
    borderRadius: '8px',
    boxShadow: 'rgba(0, 0, 0, 0.04) 0px 3px 5px',
  },
  PatientBoxPadded: {
    marginTop: '8px',
    marginBottom: '90px',
    display: 'flex',
    '#radiocheck': {
      marginLeft: 'auto',
    },
    backgroundColor: '#fff',
    padding: '16px',
    borderRadius: '8px',
    boxShadow: 'rgba(0, 0, 0, 0.04) 0px 3px 5px',
  },
  PatientBoxDisabled: {
    marginTop: '8px',
    display: 'flex',
    '#radiocheck': {
      marginLeft: 'auto',
    },
    backgroundColor: 'rgba(255, 255, 255, 0.50)',
    padding: '16px',
    borderRadius: '8px',
    boxShadow: 'rgba(0, 0, 0, 0.04) 0px 3px 5px',
    '.profileimg': {
      opacity: 0.5,
    },
  },
  BottomBox: {
    position: 'fixed',
    bottom: 0,
    width: '100%',
  },
  MemberCountText: {
    color: '#3C3C3C', fontSize: 14, fontFamily: 'Montserrat', fontWeight: '600', wordWrap: 'break-word', width: '50%',
  },
  AccordionSummaryBox: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
  },
  AddToText: {
    marginLeft: '-12px',
    color: 'white',
    fontSize: 16,
    fontFamily: 'Montserrat',
    fontWeight: '600',
    wordWrap: 'break-word',
    width: '100%',
  },
  ProceedButton: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#FF970A',
    borderRadius: 2,
    height: '48px',
    color: '#fff',
    width: '50%',
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: '600',
    textTransform: 'none',
    svg: {
    },
    boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.04)',
    ':hover': {
      color: '#fff',
      backgroundColor: '#FF970A',
    },
  },
  AddMemberButton: {
    maxHeight: '40px',
    backgroundColor: '#fff',
    borderRadius: 2,
    padding: '20px',
    width: `${window.screen.width - 32}px`,
    marginTop: '24px',
    height: '40px',
    color: '#FF970A',
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: '600',
    textTransform: 'none',
    border: '1px solid #FF970A',
    boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.04)',
    ':hover': {
      color: '#fff',
      backgroundColor: '#fff',
      border: '1px solid #FF970A',
    },
  },
  AddMemberButtonEditMode: {
    maxHeight: '40px',
    backgroundColor: '#fff',
    borderRadius: 2,
    padding: '20px',
    width: `${window.screen.width - 32}px`,
    marginTop: '8px',
    height: '40px',
    color: '#FF970A',
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: '600',
    textTransform: 'none',
    border: '1px solid #FF970A',
    boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.04)',
    ':hover': {
      color: '#fff',
      backgroundColor: '#fff',
      border: '1px solid #FF970A',
    },
  },
  CardContinueButton: {
    marginLeft: '16px',
    marginRight: '16px',
    marginBottom: '16px',
    backgroundColor: '#FF970A',
    borderRadius: 2,
    padding: 3,
    width: `${window.screen.width - 32}px`,
    marginTop: '16px',
    height: '40px',
    color: '#fff',
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: '600',
    textTransform: 'none',
    boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.04)',
    ':hover': {
      color: '#fff',
      backgroundColor: '#FF970A',
    },
  },
};

export const OrderSummaryStyles = {
  MemberDetailsCard: {
    marginLeft: '16px',
    marginRight: '16px',
    marginTop: '16px',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.06)',
    borderRadius: 4,
  },
  CustomerHeader: {
    display: 'flex',
    alignItems: 'center',
    margin: '8px',
    padding: '8px',
    borderRadius: 2,
    backgroundColor: '#FBF9F2',
  },
  DetailsContainer: {
    // margin: '16px 16px 0',
  },
  ReportDetails: {
    padding: '16px 16px 0',
    borderBottom: '1px solid #f6f6f6',
  },
  VialsContainer: {
    padding: '0 16px',
  },
  AgeContainer: {
    display: 'flex',
  },
  Dot: {
    height: 16,
    margin: '0 4px',
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#D9D9D9',
  },
  Gender: {
    height: 16,
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#616161',
  },
  TimingHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '4px',
  },
  OrderSummaryContainer: {
    margin: '32px 0',
  },
  OrderSummaryTypo: {
    marginLeft: '16px',
    marginTop: '16px',
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#616161',
  },
  Name: {
    marginLeft: '8px',
    fontFamily: 'Montserrat',
    fontSize: 16,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#616161',
  },
  Age: {
    height: 16,
    marginLeft: '8px',
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#616161',
  },
  TimingHeaderText: {
    marginLeft: '8px',
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#3c3c3c',
  },
  AccordionSummaryBox: {
    display: 'flex',
    alignItems: 'center',
    maxWidth: '200px',
  },
  ReportAccordionContainer: {
    borderBottom: '1px solid #f6f6f6',
  },
  ExtraSpace: {
    minHeight: '80px',
  },
};

export const ReportSetAccordion = {
  Accordion: {
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    '&:before': {
      display: 'none',
    },
    '&.Mui-expanded': {
      borderBottomLeftRadius: 8,
      borderBottomRightRadius: 8,
    },
    '.MuiButtonBase-root': {
      padding: '0px',
    },
    '.MuiAccordionSummary-contentGutters': {
      margin: '16px 0',
    },
    '.MuiAccordion-gutters': {
      margin: '16px 0',
    },
    '.MuiAccordionDetails-root': {
      padding: '8px 0 0',
    },
  },
  Divider: {
    margin: '12px 0',
    borderBottom: '1px dashed #d8d8d8',
  },
  ReportCardHeader: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  AccordionExpanded: {
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    '&:before': {
      display: 'none',
    },
    '&.Mui-expanded': {
      margin: '0',
      borderBottomLeftRadius: 8,
      borderBottomRightRadius: 8,
    },
    '.MuiAccordionDetails-root': {
      padding: '8px 0',
    },
  },
  ArrowIcon: {
    width: 24,
    height: 24,
  },
  AccordionSummaryBox: {
    display: 'flex',
    alignItems: 'center',
    maxWidth: '200px',
    borderRadius: 1,
    padding: '2px 4px',
    width: 'max-content',
    background: 'linear-gradient(90deg, #01B37A 0%, #66D1AF 100%)',
  },
  AccordionSummary: {
    '&.Mui-expanded': {
      minHeight: '1px',
      padding: '0px',
      '.MuiAccordionSummary-content': {
        margin: '16px 0px',
      },
    },
  },
  SetNumber: {
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#fff',
  },
  TimingContainer: {
    display: 'flex',
  },
  Date: {
    height: 18,
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#616161',
  },
  Dot: {
    height: 18,
    margin: '0 5px',
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#D9D9D9',
  },
  Time: {
    height: 18,
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#616161',
  },
  Report: {
    height: 16,
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#616161',
    margin: '0 4px 2px 0',
  },
  AccordionDetails: {
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 4,
  },
};

export const TestCardStyles = {
  TestType: {
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '600',
    lineHeight: '16px',
    color: '#8a8a8a',
    marginBottom: '8px',
  },
  TestNameIcon: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '8px',
  },
  TestName: {
    marginLeft: '4px',
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: '500',
    lineHeight: '18px',
    color: '#616161',
  },
};

export const vialAccordionStyles = {
  Accordion: {
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    '&:before': {
      display: 'none',
    },
    '&.Mui-expanded': {
      borderBottomLeftRadius: 8,
      borderBottomRightRadius: 8,
    },
    '.MuiButtonBase-root': {
      padding: '0px',
    },
    '.MuiAccordionSummary-contentGutters': {
      margin: '16px 0',
    },
    '.MuiAccordion-gutters': {
      margin: '16px 0',
    },
    '.MuiAccordionDetails-root': {
      padding: '8px 0 0',
    },
  },
  AccordionExpanded: {
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    '&:before': {
      display: 'none',
    },
    '&.Mui-expanded': {
      borderBottomLeftRadius: 8,
      borderBottomRightRadius: 8,
    },
  },
  ArrowIcon: {
    width: 24,
    height: 24,
  },
  Divider: {
    margin: '16px 0',
    borderBottom: '1px solid #f6f6f6',
  },
  AccordionSummaryBox: {
    display: 'flex',
    alignItems: 'center',
    maxWidth: '200px',
    borderRadius: 2,
    padding: '2px 4px 2px 0',
  },
  AccordionSummary: {
    '.MuiAccordionSummary-content': {
      margin: '16px 0',
    },
    '&.Mui-expanded': {
      minHeight: '1px',
      padding: '0px',
      '.MuiAccordionSummary-content': {
        margin: '16px 0px',
      },
    },
  },
  SetNumber: {
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#3c3c3c',
    marginLeft: '8px',
  },
  AccordionDetails: {
    padding: '0',
    margin: '0 0 16px',
  },
};

export const VialSummaryCardStyles = {
  Card: {
    borderRadius: 0,
  },
  VialText: {
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    marginLeft: '2px',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#9d9d9d',
    b: {
      fontFamily: 'Montserrat',
      fontSize: 12,
      fontWeight: '600',
      fontStyle: 'normal',
      letterSpacing: 0,
      color: '#01b37a',
    },
  },
  ScanBox: {
    marginTop: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  Scanned: {
    marginLeft: '4px',
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#01b37a',
  },
  ScannedBox: {
    display: 'flex',
  },
  SkippedBox: {
    display: 'flex',
  },
  Skipped: {
    marginLeft: '4px',
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#b39901',
  },
  VialName: {
    marginLeft: '12px',
    width: `${window.screen.width * 0.5}px`,
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#616161',
  },
  UavBadge: {
    height: '32px',
    display: 'flex',
    borderRadius: 1,
    marginTop: '16px',
    marginBottom: '16px',
    backgroundColor: '#f6f6f6',
    alignItems: 'center',
  },
  UavDes: {
    width: '4px',
    borderBottomRightRadius: 5,
    borderTopRightRadius: 5,
    height: '24px',
    backgroundColor: '#b39901',
  },
  UavText: {
    marginLeft: '8px',
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#616161',
  },
  List: {
    li: {
      fontFamily: 'Montserrat',
      fontSize: 12,
      fontWeight: '500',
      fontStyle: 'normal',
      letterSpacing: 0,
      color: '#9d9d9d',
    },
    display: 'grid',
    marginLeft: '4px',
    marginTop: '12px',
  },
  ListText: {
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#9d9d9d',
  },
  ListDot: {
    marginRight: '4px',
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#9d9d9d',
  },
};

export const OrderSuccessStyles = {
  SuccessCard: {
    display: 'flex',
    marginTop: '24px',
    marginLeft: '16px',
    marginRight: '16px',
    borderRadius: 4,
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.06)',
    '#lottiesuccess': {
      marginTop: '16px',
    },
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  SuccessReq: {
    marginTop: '24px',
    height: 18,
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'center',
    color: '#3c3c3c',
  },
  CardTypoVialSuccess: {
    marginTop: '12px',
    height: 20,
    fontFamily: 'Montserrat',
    fontSize: 16,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'center',
    color: '#3c3c3c',
  },
  DoneCTA: {
    position: 'fixed',
    bottom: 0,
    width: '100%',
    height: '72px',
    backgroundColor: '#fff',
    display: 'flex',
    alignItems: 'center',
    boxShadow: '0px -2px 6px 0px rgba(0, 0, 0, 0.16)',
  },
  SuccessDetails: {
    marginTop: '16px',
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'center',
    color: '#616161',
  },
  SuccessDetailsRnr: {
    marginTop: '16px',
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'center',
    color: '#616161',
    marginBottom: '18px',
  },
  SuccessDetailsEx: {
    marginBottom: '24px',
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'center',
    color: '#616161',
  },
};
